import { KbFolderModel } from 'types/KbFolderTypes';
import useHttp from '../helpers/HttpMethods';

class KbGroupFoldersSevice {
  static async list(kbGroupId: number): Promise<KbFolderModel[]> {
    return useHttp().get(`/kb-groups/${kbGroupId}/kb-folders`);
  }
}

export default KbGroupFoldersSevice;
